
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaicabservice() {



  const cardData =
  {
    keyword: 'Mumbai Cab Service',
    heading: 'AB Ghule Cabs: Mumbai Cab Service',
    headingDescription: 'When it comes to reliable and comfortable cab services in Mumbai, AB Ghule Cabs is your go-to option. Our cab service is designed to ensure seamless travel experiences, whether you  are a tourist exploring the city is vibrant life or a resident commuting to your destination. With top-notch vehicles and professional drivers, we prioritize your comfort and safety.',

    top: 'Top Places to Visit in Mumbai with AB Ghule Cabs',

    topPlaces: [
      {
        title: "Gateway of India",
        description: "A grand monument by the Arabian Sea, the Gateway of India is an iconic landmark symbolizing Mumbai’s rich history and architecture. Built in 1911 to commemorate the visit of King George V and Queen Mary, the archway stands tall at 26 meters and is one of the most recognized symbols of Mumbai. It offers stunning views of the Arabian Sea and is a popular starting point for visitors exploring the city."
      },
      {
        title: "Marine Drive",
        description: "Known as the Queen’s Necklace, Marine Drive is a picturesque 3.6-kilometer-long promenade that stretches along the Arabian Sea, offering stunning views of the coastline. The curved road lined with Art Deco buildings forms a necklace-like shape when lit up at night. Marine Drive is perfect for a leisurely stroll or a peaceful escape from the city’s hustle and bustle, with panoramic views of the sunset and the city skyline."
      },
      {
        title: "Chhatrapati Shivaji Maharaj Terminus (CST)",
        description: "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus (formerly Victoria Terminus) is a historic railway station that combines Victorian Gothic and Indian architectural styles. Completed in 1887, this landmark features intricate carvings, stunning domes, and an impressive facade. The station is an architectural marvel and serves as a major transport hub, connecting Mumbai to various parts of India. The building is a testament to the city’s colonial past and remains one of the busiest railway stations in the country."
      },
      {
        title: "Elephanta Caves",
        description: "Located on Elephanta Island, just a short ferry ride from the city, Elephanta Caves are a UNESCO World Heritage Site renowned for their ancient rock-cut temples and sculptures dedicated to Hindu gods. The island features a series of caves carved into the mountainside, with the most famous being the large temple dedicated to Lord Shiva. The intricate carvings and majestic statues, including a 20-foot-high sculpture of Trimurti (a three-headed Shiva), attract history enthusiasts and spiritual seekers alike."
      },
      {
        title: "Juhu Beach",
        description: "A lively and vibrant destination, Juhu Beach is one of Mumbai's most popular spots for both locals and tourists. Famous for its street food stalls, particularly pav bhaji and bhel puri, the beach offers a mix of relaxation and recreation. Visitors can enjoy the cool sea breeze, watch the mesmerizing sunset, or engage in various activities such as horse riding, cycling, or playing cricket. Juhu is also home to several Bollywood celebrities, and its proximity to the airport adds to its allure."
      },
      {
        title: "Siddhivinayak Temple",
        description: "Dedicated to Lord Ganesha, Siddhivinayak Temple is one of the most revered and visited temples in Mumbai. The temple, which dates back to 1801, is famous for its beautiful wooden doors adorned with carvings of Ashtavinayak, the eight forms of Lord Ganesha. The temple attracts thousands of devotees daily, who come to seek blessings for success and prosperity. The temple’s serene and divine atmosphere makes it an essential part of Mumbai’s spiritual landscape."
      },
      {
        title: "Haji Ali Dargah",
        description: "Haji Ali Dargah is an iconic mosque and shrine dedicated to Haji Ali, a wealthy merchant who became a saint. Situated on a small islet in the Arabian Sea, the shrine is accessible via a narrow causeway that is submerged during high tide. The dargah is a blend of Indo-Islamic architecture and is one of the most visited religious sites in Mumbai. Visitors from all walks of life come to pay homage, making it a symbol of faith, unity, and spirituality in the city."
      },
      {
        title: "Bandra-Worli Sea Link",
        description: "A modern engineering marvel, the Bandra-Worli Sea Link is a cable-stayed bridge that connects the neighborhoods of Bandra and Worli. Opened in 2009, the 5.6-kilometer bridge offers breathtaking views of the Mumbai skyline, the Arabian Sea, and the coastline. The bridge, designed to ease traffic congestion between the suburbs and the main city, is an iconic part of Mumbai's urban landscape and a must-visit for architecture and photography enthusiasts."
      },
      {
        title: "Colaba Causeway",
        description: "Colaba Causeway is a vibrant and bustling street in South Mumbai, renowned for its eclectic mix of shops, street vendors, and iconic cafes like Leopold Café. The street is a shopper’s paradise, offering a variety of goods, from fashionable clothing and accessories to antiques and handicrafts. Colaba Causeway also boasts a rich history, with colonial-era buildings and proximity to famous landmarks like the Gateway of India and the Taj Mahal Palace Hotel."
      },
      {
        title: "Film City",
        description: "The heart of Bollywood, Film City is a sprawling studio complex in Goregaon that serves as the backdrop for countless Indian films and television shows. Visitors can take guided tours to explore the movie sets, studios, and soundstages, offering an insider’s view of the filmmaking process. Film City is a must-visit for fans of Indian cinema, providing an opportunity to witness the magic of Bollywood and learn about its vibrant history and production techniques."
      }
    ],


    services: [
      {
        "name": "Mumbai Cab Service for Outstation",
        description: "Looking for a reliable Mumbai cab service for outstation travel? AB Ghule Cabs offers competitive rates for outstation cabs from Mumbai. Our transparent pricing structure ensures you get the best value, with no hidden charges. Whether you're heading to nearby destinations or faraway locations, our well-maintained vehicles and professional drivers will make your journey comfortable and hassle-free."
      },
      {
        "name": "Cheapest Cab Service in Mumbai",
        description: "AB Ghule Cabs provides the cheapest cab service in Mumbai, without compromising on quality. Our affordable rates make it easy for you to travel across the city and to outstation destinations, with a fleet of well-maintained vehicles and experienced drivers ensuring a smooth and enjoyable ride."
      },
      {
        "name": "Mumbai Cab Service for Outstation Cost per Day",
        description: "For outstation travel from Mumbai, AB Ghule Cabs offers daily rental options at competitive rates. Whether you need a car for a short trip or an extended journey, our transparent pricing ensures you know exactly what you're paying for, with no hidden fees."
      },
      {
        "name": "Best Outstation Cab Service in Mumbai",
        description: "AB Ghule Cabs is known for offering the best outstation cab services in Mumbai. Our fleet includes well-maintained vehicles and professional drivers, making us the ideal choice for long-distance travel. Enjoy a comfortable and affordable journey with our trusted service."
      },
      {
        "name": "Rent a Car in Mumbai for Outstation",
        description: "Rent a car for your outstation journey from Mumbai with AB Ghule Cabs. We provide a wide variety of vehicles for different group sizes and preferences. Whether it's a short getaway or a long-distance trip, our rental options cater to all your travel needs with modern amenities for a comfortable ride."
      },
      {
        "name": "Mumbai Taxi Service",
        description: "AB Ghule Cabs provides efficient and reliable Mumbai taxi services. Whether you're traveling locally or need a ride for an outstation trip, our fleet of taxis and experienced drivers guarantee a comfortable and smooth journey across the city or beyond."
      },
      {
        "name": "Cheapest Cab Service in Mumbai",
        description: "Looking for a budget-friendly cab service in Mumbai? AB Ghule Cabs offers affordable rates for both local and outstation rides. We ensure that you get great service and reliable vehicles without breaking the bank."
      },
      {
        "name": "Outstation Cabs in Mumbai",
        description: "When you need an outstation cab in Mumbai, AB Ghule Cabs offers a range of options. We cater to your long-distance travel needs with comfortable, well-maintained vehicles, ensuring a hassle-free experience at competitive prices."
      },
      {
        "name": "Bombay Pune Taxi",
        description: "Travel from Bombay to Pune comfortably with AB Ghule Cabs’ taxi service. We offer reliable, affordable, and comfortable rides between these two cities, with well-maintained vehicles and experienced drivers ensuring a smooth trip every time."
      },
      {
        "name": "Bombay to Pune Cab",
        description: "Book a Bombay to Pune cab with AB Ghule Cabs for a comfortable and reliable journey. We offer transparent pricing and flexible booking options for your convenience, ensuring you can enjoy your trip without any worries."
      },
      {
        "name": "Mumbai to Pune Taxi Fare",
        description: "Check out our competitive Mumbai to Pune taxi fare at AB Ghule Cabs. We provide transparent pricing with no hidden charges, ensuring an affordable and comfortable ride between the two cities. Our experienced drivers will ensure a smooth and safe journey."
      },
      {
        "name": "Cabs in Mumbai",
        description: "Looking for cabs in Mumbai? AB Ghule Cabs offers a wide selection of vehicles for all your travel needs. Whether you're traveling within the city or going on an outstation trip, we provide reliable, affordable, and comfortable options."
      },
      {
        "name": "Taxi Fare in Mumbai",
        description: "AB Ghule Cabs offers competitive taxi fares in Mumbai. Our pricing is clear and transparent, ensuring that you know exactly what you're paying for, whether it's a local ride or an outstation journey."
      },
      {
        "name": "Mumbai Taxi",
        description: "Choose AB Ghule Cabs for your Mumbai taxi needs. Our fleet of well-maintained vehicles and professional drivers ensures a safe and comfortable ride across the city or for your outstation trips. Enjoy affordable rates and reliable service every time."
      },
      {
        "name": "Online Cab Booking Mumbai",
        description: "Book your cab in Mumbai easily through our online platform. With AB Ghule Cabs, you can choose from a variety of vehicles, schedule your ride, and make payments conveniently from anywhere, ensuring a smooth booking experience for your travel."
      },
      {
        "name": "Taxi Booking Mumbai",
        description: "Need to book a taxi in Mumbai? AB Ghule Cabs offers a convenient taxi booking service for local and outstation trips. Our professional drivers and reliable vehicles ensure you get to your destination safely and comfortably."
      },
      {
        "name": "Taxi for Mumbai Darshan",
        description: "Book a taxi for Mumbai darshan with AB Ghule Cabs. Our drivers will take you to all major tourist spots in Mumbai, ensuring you have a comfortable and hassle-free experience while exploring the city’s landmarks."
      },
      {
        "name": "Mumbai Cab Service Contact Number",
        description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Mumbai Cab Service. We ensure a smooth and enjoyable ride for all our customers."
      }
    ],

    tableData: [
      ["- Mumbai cab service for outstation", "- Cheapest cab service in Mumbai"],
      ["- Mumbai cab service for outstation cost per day", "- Best outstation cab service in Mumbai"],
      ["- Rent a car in Mumbai for outstation", "- Mumbai taxi service"],
      ["- Cheapest cab service in Mumbai", "- Outstation cabs Mumbai"],
      ["- Bombay Pune taxi", "- Bombay to Pune cab"],
      ["- Mumbai to Pune taxi fare", "- Cabs in Mumbai"],
      ["- Taxi fare in Mumbai, Mumbai taxi", "- Online cab booking Mumbai"],
      ["- Taxi booking Mumbai", "- Taxi for Mumbai darshan"]
    ],

    whychoose: [
      {
        WhyChooseheading: "Reliable and Professional Service",
        WhyChoosedescription: "At AB Ghule Cabs, we pride ourselves on providing reliable and professional cab services across Mumbai. Our drivers are well-trained, courteous, and committed to offering you a safe and comfortable ride."
      },
      {
        WhyChooseheading: "24/7 Availability",
        WhyChoosedescription: "Whether you need a ride early in the morning or late at night, we are available 24/7 to cater to your travel needs in Mumbai. Our customer service is always ready to assist you in booking a ride at any time."
      },
      {
        WhyChooseheading: "Affordable Rates",
        WhyChoosedescription: "We offer competitive pricing with transparent fare structures, ensuring that you get value for your money without any hidden charges. Whether it's a short trip or a long journey, our prices are designed to suit all budgets."
      },
      {
        WhyChooseheading: "Clean and Well-Maintained Fleet",
        WhyChoosedescription: "Our vehicles are regularly cleaned, maintained, and inspected to ensure that they are in perfect condition. We offer a range of cars, from budget-friendly to luxury options, to suit different preferences."
      },
      {
        WhyChooseheading: "Safe and Comfortable Rides",
        WhyChoosedescription: "We prioritize your safety with trained, experienced, and background-checked drivers. Our vehicles are equipped with GPS for a smooth and safe ride through Mumbai's busy roads."
      },
      {
        WhyChooseheading: "Easy Booking Process",
        WhyChoosedescription: "Booking a cab with AB Ghule Cabs is quick and easy. You can book online via our website or app, or simply call our customer service for immediate assistance."
      },
      {
        WhyChooseheading: "Customer Satisfaction",
        WhyChoosedescription: "We have a proven track record of customer satisfaction, with numerous positive reviews from our regular customers. We are always ready to improve and ensure that your travel experience with us is seamless and enjoyable."
      }
    ]

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab with AB Ghule Cabs?',
      answer: 'You can book a cab with AB Ghule Cabs through our website, mobile app, or by calling our customer service helpline. We offer an easy booking process for your convenience.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all our drivers are highly trained, experienced, and background-checked to ensure your safety and comfort throughout the ride.',
    },
    {
      id: 'FAQ3',
      question: 'Do you offer airport pick-up and drop services?',
      answer: 'Yes, we provide airport pick-up and drop services for both domestic and international flights. Our drivers are punctual and will ensure you reach the airport or your destination on time.',
    },
    {
      id: 'FAQ4',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, catering to various needs, whether it\'s for business travel, leisure, or group rides.',
    },
    {
      id: 'FAQ5',
      question: 'How do I pay for my ride?',
      answer: 'You can pay for your ride through multiple options, including cash, credit/debit cards, or online payment through our mobile app, providing you with flexibility and convenience.',
    },
    {
      id: 'FAQ6',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'There may be additional charges for waiting time or detours, depending on the nature of the trip. However, we ensure transparent pricing, and any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ7',
      question: 'How do I cancel or modify my booking?',
      answer: 'You can easily modify or cancel your booking through our website or app. If you need assistance, you can also contact our customer service for help with cancellations or changes.',
    },
    {
      id: 'FAQ8',
      question: 'Do you offer intercity services?',
      answer: 'Yes, we offer intercity cab services, allowing you to travel comfortably between Mumbai and nearby cities. You can book a cab for long-distance trips at affordable rates.',
    },
    {
      id: 'FAQ9',
      question: 'Is AB Ghule Cabs available for corporate travel?',
      answer: 'Yes, we offer corporate travel solutions for businesses, including regular rides for employees, meetings, events, and more. Contact us to discuss custom packages for your company.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other cab services in Mumbai?',
      answer: 'AB Ghule Cabs stands out because of our commitment to customer satisfaction, affordable pricing, experienced drivers, a wide range of vehicles, and excellent customer support. We focus on providing a personalized and safe travel experience in Mumbai.',
    },
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Sandeep Verma",
      feedback: "I have been using AB Ghule Cabs for my regular trips around Mumbai, and I must say, the service has been impeccable. The drivers are always on time, the cars are clean, and the journey is always smooth. It's the perfect option for both business and personal travel. Highly recommend AB Ghule Cabs to anyone looking for reliable and professional cab services!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Priya Deshmukh",
      feedback: "I needed a last-minute ride to the airport, and AB Ghule Cabs came through without a hitch. The booking process was simple, the driver was professional and friendly, and I reached the airport on time without any stress. This is definitely my go-to cab service in Mumbai.",
      rating: 5,
    },
  ];







  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];




  return (
    
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Mumbai Cab Service | Mumbai Cab Service for Outstation</title>
  <meta name="description" content="Mumbai cab service for outstation, the cheapest cab service in Mumbai for various destinations including Mumbai to Pune, Mumbai to Goa, and more. Book a taxi online for your trips with professional drivers." />
  <meta name="keywords" content="Mumbai Cab Service for Outstation, Cheapest Cab Service in Mumbai, Mumbai Taxi Service, Mumbai to Pune Taxi, Bombay Pune Taxi, Mumbai to Goa Cab, Outstation Cabs Mumbai, Online Cab Booking Mumbai" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Mumbai Cab Service | Mumbai Cab Service for Outstation" />
  <meta property="og:description" content="Mumbai cab service for outstation, the cheapest cab service in Mumbai for various destinations including Mumbai to Pune, Mumbai to Goa, and more. Book a taxi online for your trips with professional drivers." />
  <meta property="og:image" content="https://abghulecabs.com/images/mumbai-cab-service.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/mumbai-cab-service" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />
  
  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs",
        description: "Mumbai cab service for outstation, the cheapest cab service in Mumbai for various destinations including Mumbai to Pune, Mumbai to Goa, and more. Book a taxi online for your trips with professional drivers.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Mumbai, Maharashtra",
          "addressLocality": "Mumbai",
          "addressRegion": "Maharashtra",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/mumbai-cab-service",
        "logo": "https://abghulecabs.com/images/mumbai-cab-service.jpg",
        "image": "https://abghulecabs.com/images/mumbai-cab-service.jpg",
        "priceRange": "₹2000 - ₹8000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/mumbai-cab-service",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "1500"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh Kumar"
            },
            "datePublished": "2024-11-10",
            "reviewBody": "Great service! The driver was professional, and the cab was in perfect condition. Highly recommended for outstation trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suman Verma"
            },
            "datePublished": "2024-10-05",
            "reviewBody": "Affordable and reliable service. The ride from Mumbai to Pune was smooth and enjoyable. I will definitely use AB Ghule Cabs again."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Mumbai",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "19.0760",
            "longitude": "72.8777"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/mumbai-cab-service"
        },
        "keywords": "Mumbai Cab Service for Outstation, Cheapest Cab Service in Mumbai, Mumbai Taxi Service, Mumbai to Pune Taxi, Bombay Pune Taxi, Mumbai to Goa Cab, Outstation Cabs Mumbai, Online Cab Booking Mumbai"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/1.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                   {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaicabservice;